import {
  debugModeAvailable,
  isDevelop,
  isStaging,
} from '@/scripts/environments'
import { Box, HStack, Tag, Text } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { Header } from '@hivemq/ui-library'
import { useOktaAuth } from '@okta/okta-react'
import { Link } from '@tanstack/react-router'
import { UserIcon } from 'lucide-react'
import { SettingsToolbar } from '../toolbar/SettingsToolbar'
import { StaffIdentityDetails } from './StaffIdentityDetails'

export function NavigationBar() {
  const { oktaAuth } = useOktaAuth()

  const showEnvTag = isStaging || isDevelop
  const bgColor = isStaging ? 'purple.800' : 'blue.800'
  const colorPalette = isStaging ? 'purple' : 'blue'
  const envTag = isStaging ? 'Staging' : 'Dev'
  const transparency = '0.05'
  const title = (
    <HStack gap={3}>
      <Text>Backoffice</Text>
      {showEnvTag && (
        <Tag.Root
          colorPalette={colorPalette}
          borderRadius="full"
          variant="solid"
          size="lg"
        >
          <Tag.Label fontWeight="bold">{envTag}</Tag.Label>
        </Tag.Root>
      )}
    </HStack>
  ) as unknown as string // yes it's a hack but only way to make it build

  const StyledHeaderLogo = styled(Header.Logo)`
  img {
    padding: 2px;
    height: 40px;
  }
`

  return (
    <Header.Root>
      <HStack alignItems="center" w="full">
        {/* Override header to highlight the environment we're in */}
        {showEnvTag && (
          <Box
            backgroundColor={bgColor}
            backgroundSize="2rem 2rem"
            backgroundImage={`linear-gradient(-45deg, rgba(255, 255, 255, ${transparency}) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, ${transparency}) 50%, rgba(255, 255, 255, ${transparency}) 75%, transparent 75%, transparent)`}
            w="100%"
            h="var(--nav-bar-height)"
            position="fixed"
            zIndex="-1"
          />
        )}
        <Header.SidebarToggle />
        <Link to="/">
          <StyledHeaderLogo
            src={`${import.meta.env.BASE_URL}logo-bee-bw.svg`}
            alt="HiveMQ Cloud Logo"
            title={title}
            p={0}
          />
        </Link>
        <Box flexGrow="2" textAlign="right" pr={6} mr="auto">
          <HStack gap={4} justifyContent="flex-end">
            <SettingsToolbar />
            <Header.Menu overlayId="profile">
              <Header.MenuButton icon={UserIcon} aria-label="Profile" />
              <Header.MenuContent>
                <Header.MenuContentDetails textAlign="center">
                  <b>Hello 👋</b>
                  <br />
                  Welcome back!
                </Header.MenuContentDetails>
                {debugModeAvailable && <StaffIdentityDetails />}
                <Header.MenuContentItem
                  ariaLabel="Logout"
                  onClick={() =>
                    oktaAuth.signOut({
                      clearTokensBeforeRedirect: true,
                      postLogoutRedirectUri: window.location.origin,
                    })
                  }
                  _hover={{
                    backgroundColor: 'red.600',
                  }}
                >
                  Logout
                </Header.MenuContentItem>
              </Header.MenuContent>
            </Header.Menu>
          </HStack>
        </Box>
      </HStack>
    </Header.Root>
  )
}
